<template>
  <v-autocomplete ref="input" v-bind="attributes" v-on="$listeners"></v-autocomplete>
</template>

<script>
import form_mixin from "./form_mixin";

export default {
  name: "z-autocomplete",

  mixins: [form_mixin],

  computed: {
    attributes() {
      if (this.configOff) {
        return { ...this.$attrs };
      }
      return { ...this.$v.TEXT_FIELDS, ...this.$attrs };
    },
  },
}
</script>

<style lang="scss" scoped>
</style>